import React, { useEffect, useState } from "react";
import { Drawer, DrawerBody, DrawerFooter, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton } from "@chakra-ui/react";
import Select from "react-select";
import { toast } from "react-toastify";
import { FaStar } from "react-icons/fa6";
import { useDispatch } from "react-redux";
import { updateProductReviewApi } from "../../../redux/reduxApi/admin/ProductReviewApi";
import { getLoggedInUserId } from "../../../../utils/authUtils";
import { reviewStatus } from "../utils/SearchPickList";
export default function ProductReviewForm({ closeDrawer, isDrawerOpen, updatedData }) {
  console.log("updatedData", updatedData);
  const loggedInUserId = getLoggedInUserId();

  const dispatch = useDispatch();
  const customStyle = {
    control: (baseStyles) => ({
      ...baseStyles,
      borderColor: "rgb(93, 135, 255)",
      borderRadius: "8px",
      border: "0.5px solid rgb(196,196,196,0.5) !important",
      marginRight: "10px",
    }),
  };
  const [formData, setFormData] = useState({
    orderNo: "",
    review: "",
    rating: "",
    status: "unapproved",
    customerName: "",
    // productId: "",
  });

  useEffect(() => {
    if (updatedData) {
      setFormData({
        // productName: updatedData?.products?.name,
        orderNo: updatedData?.orderNo || "",
        customerName: updatedData?.webuser?.firstName || "",
        review: updatedData?.review || "",
        rating: updatedData?.rating || 0,
        status: updatedData?.status || "unapproved",
        // productId: updatedData?.productId,
      });
    }
  }, [updatedData]);

  const handleStatusChange = (selectedOption) => {
    console.log("Selected option:", selectedOption);
    setFormData({ ...formData, status: selectedOption.value });
  };

  const handelSubmit = async (e) => {
    e.preventDefault();
    console.log("Form Data Submitted:", formData);
    try {
      const response = await dispatch(updateProductReviewApi({ ...formData, rowId: updatedData?.ROWID, modifiedBy: loggedInUserId })).unwrap();
      toast.success("Product Review Updated Successfully!");
      closeDrawer();
    } catch (error) {
      toast.error("Failed to update Product Review!");
    }
  };

  return (
    <Drawer isOpen={isDrawerOpen} placement="right" size="lg" onClose={closeDrawer}>
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader className="bg-[#EFF6FF]">Edit Product Review</DrawerHeader>
        <DrawerBody className="bg-[#EFF6FF]">
          <form>
            <div className="card mb-4">
              <div className="card-body">
                <div className="row">
                  {/* <div className="col-lg-6 clo-12 col-md-6">
                    <div className="mb-3">
                      <label htmlFor="productName" className="small-label">
                        Product Name
                      </label>
                      <input type="text" name="productName" value={formData.productName} readOnly required className="form-control border-2 border-orange-500" />
                    </div>
                  </div> */}
                  <div className="col-lg-6 clo-12 col-md-6">
                    <div className="mb-3">
                      <label className="font-medium mb-1 small-label">Rating</label>
                      <div className="flex items-center gap-1">
                        {[...Array(5)].map((_, i) => (
                          <FaStar key={i} className={i < formData.rating ? "text-yellow-500" : "text-gray-300"} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-6 clo-12 col-md-6">
                    <div className="mb-3">
                      <label htmlFor="userId" className="small-label">
                        Customer Name
                      </label>
                      <input type="text" name="customerName" value={formData.customerName} isDisabled={true} required className="form-control" />
                    </div>
                  </div>
                  <div className="col-lg-6 clo-12 col-md-6">
                    <div className="mb-3">
                      <label className="font-medium mb-1 small-label">Status</label>
                      <Select styles={customStyle} value={reviewStatus.find((status) => status.value === formData.status)} onChange={handleStatusChange} options={reviewStatus} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12 clo-12 col-md-12">
                    <div className="mb-3">
                      <label htmlFor="review" className="small-label">
                        Review
                      </label>
                      <textarea value={formData.review} readOnly className="form-control border-2 border-orange-500" id="review" name="review" rows="5" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </DrawerBody>
        <DrawerFooter style={{ display: "block" }} className="bg-[#EFF6FF]">
          <div className="gap-3 flex justify-center">
            <button variant="outline" mr={3} onClick={closeDrawer} className="cancel-button">
              Cancel
            </button>
            <button className="main-btn mx-2" onClick={handelSubmit}>
              Update
            </button>
          </div>
        </DrawerFooter>
        {/* <DrawerFooter>
                    <center>
                        <Button variant="outline" mr={3} onClick={closeDrawer}>
                            Cancel
                        </Button>
                        <Button colorScheme="orange">Update</Button>
                    </center>
                </DrawerFooter> */}
      </DrawerContent>
    </Drawer>
  );
}
